import React, { useState, useEffect } from "react";
import { Area } from "@ant-design/plots";
import styled from "styled-components";
import { formatDataNumberToen } from "../../helper/helper";

export default function DailyRevenueChart({ dataRevenueChart }) {
  const data = [
    {
      chargeTime: "2010 Q4",
      value: 0,
    },
    {
      chargeTime: "2011 Q1",
      value: 0,
    },
    {
      chargeTime: "2011 Q2",
      value: 2.8,
    },
    {
      chargeTime: "2011 Q3",
      value: 0,
    },
    {
      chargeTime: "2011 Q4",
      value: 0,
    },
    {
      chargeTime: "2012 Q1",
      value: 0,
    },
    {
      chargeTime: "2012 Q2",
      value: 0,
    },
    {
      chargeTime: "2012 Q3",
      value: 0,
    },
    {
      chargeTime: "2012 Q4",
      value: 0,
    },
    {
      chargeTime: "2013 Q1",
      value: 0,
    },
    {
      chargeTime: "2013 Q2",
      value: 0,
    },
    {
      chargeTime: "2013 Q3",
      value: 0,
    },
    {
      chargeTime: "2013 Q4",
      value: 0,
    },
    {
      chargeTime: "2014 Q1",
      value: 0,
    },
    {
      chargeTime: "2014 Q2",
      value: 0,
    },
    {
      chargeTime: "2014 Q3",
      value: 0,
    },
    {
      chargeTime: "2014 Q4",
      value: 0,
    },
    {
      chargeTime: "2015 Q1",
      value: 0,
    },
    {
      chargeTime: "2015 Q2",
      value: 0,
    },
    {
      chargeTime: "2015 Q3",
      value: 0,
    },
    {
      chargeTime: "2015 Q4",
      value: 0,
    },
    {
      chargeTime: "2016 Q1",
      value: 0,
    },
    {
      chargeTime: "2016 Q2",
      value: 0,
    },
    {
      chargeTime: "2016 Q3",
      value: 0,
    },
    {
      chargeTime: "2016 Q4",
      value: 0,
    },
    {
      chargeTime: "2017 Q1",
      value: 0,
    },
    {
      chargeTime: "2017 Q2",
      value: 0,
    },
    {
      chargeTime: "2017 Q3",
      value: 0,
    },
    {
      chargeTime: "2017 Q4",
      value: 0,
    },
    {
      chargeTime: "2018 Q1",
      value: 0,
    },
  ];

  const config = {
    data: dataRevenueChart || data,
    xField: "chargeTime",
    yField: "value",
    xAxis: {
      range: [0, 1],
    },
    point: {
      size: 5,
      shape: "diamond",
      style: {
        fill: "white",
        stroke: "#5B8FF9",
        lineWidth: 2,
      },
    },

    yAxis: {
      label: {
        formatter: (v) => ` ${formatDataNumberToen(+v)} `,
      },
    },
    tooltip: {
      formatter: (datum) => ({
        name: 'value',
        value: ` ${formatDataNumberToen(+datum.value)} `,
      }),
    },
  };

  return (
    <Container className="p-3 pt-5 pb-5">
      <Area {...config} />
    </Container>
  );
}

const Container = styled.div`
  /* @media (max-width: 576px){
    padding-bottom: 0px !important;
  } */
`;
